import { gql, useQuery } from "@apollo/client";
import { ClassRoomType, SpeakingClassLevel } from "../../gql/graphql.ts";

const GetTeachersWithMissingFeedbackQuery = gql`
  query getTeachersWithMissingFeedback {
    getTeachersWithMissingFeedback {
      teacherId
      classRoomsWithMissingFeedback {
        classRoom {
          id
          type
          startedAtUtc
          speakingLevel
          is1on1
          feedbackUri
          participantsCount
          topic {
            id
            name
          }
          userGroup {
            id
            name
          }
        }
        participantsWithoutFeedback {
          id
          givenName
          familyName
        }
      }
    }
  }
`;

export type ClassRoomWithMissingFeedback = {
  classRoom: {
    id: string;
    type: ClassRoomType;
    startedAtUtc: string;
    speakingLevel: SpeakingClassLevel;
    is1on1?: boolean | null;
    feedbackUri: string;
    participantsCount: number;
    topic: { id: string; name: string };
    userGroup: { id: string; name: string };
  };
  participantsWithoutFeedback: {
    id: string;
    givenName: string;
    familyName: string;
  }[];
};

export type TeacherWithMissingFeedback = {
  teacherId: string;
  classRoomsWithMissingFeedback: ClassRoomWithMissingFeedback[];
};

export function useTeachersWithMissingFeedback() {
  const { data, loading } = useQuery(GetTeachersWithMissingFeedbackQuery, {
    fetchPolicy: "cache-and-network",
  });

  const teachersWithMissingFeedback: TeacherWithMissingFeedback[] =
    data?.getTeachersWithMissingFeedback ?? [];

  return { teachersWithMissingFeedback, loading };
}
